import classes from "./Custom-icon.module.css";

/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

const CustomIcon = ({
  children,
  src,
  alt,
  title,
  style = {},
  iconStyle = {},
  className,
  iconClass,
  iconHeight = "100%",
  iconWidth = "100%",
  reference,
  clickHandler = () => {},
  ...rest
}) => {
  return (
    <div
      style={{
        maxHeight: style.height,
        maxWidth: style.width,
        ...style,
      }}
      className={`${classes.container} ${className} `}
      onClick={clickHandler}
      {...rest}
      ref={reference}
    >
      <img
        width={iconWidth}
        height={iconHeight}
        src={src}
        alt={alt}
        title={title}
        className={iconClass}
        style={{ ...iconStyle }}
      />
    </div>
  );
};

export default CustomIcon;
